import { Box, Grid, Typography } from "@mui/material";
import React, { memo } from "react";
import styles from "../../Rastreabilidade.module.css";

const balaoInfoStyle = {
	display: "flex",
	justifyContent: "space-around",
	alignItems: "center",
	textAlign: "center",
	minHeight: "250px",
	height: "100%",
	p: 5,
	borderRadius: "30px",
	bgcolor: "rgba(250,250,250,0.9)",
	color: "rgba(100,100,100,0.75)",
	boxShadow: "-7px 10px 43px -15px rgba(0,0,0,0.75)",
};
const balaoInfoTopStyle = {
	bgcolor: "gray",
	width: "max-content",
	borderRadius: "15px",
	p: 2,
	ml: "20px",
	mb: -3,
	position: "relative",
	color: "white",
	boxShadow: "-7px 10px 24px -2px rgba(0,0,0,0.75)",
	fontSize: "20px",
	fontWeight: "bold",
};
const balaoInfoBottonStyle = {
	bgcolor: "gray",
	width: "max-content",
	borderRadius: "15px",
	p: 1,
	ml: "20px",
	mt: -5,
	position: "relative",
	color: "white",
	fontWeight: "bold",
	fontSize: "36px",
	boxShadow: "0px 15px 24px -5px rgb(0 0 0 / 75%)",
};

const formatDate = (valor) =>
	valor ? new Date(valor).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : "-";

function Balao({ titulo, numero, destaque, texto }) {
	return (
		<Grid size={{ xs: 12, sm: 6, md: 4 }}>
			<Box sx={balaoInfoTopStyle}>{titulo}</Box>
			<Box sx={balaoInfoStyle}>
				<Box sx={{ width: "100%" }}>
					<h3>{destaque}</h3>
					<p>{texto}</p>
				</Box>
			</Box>
			<Box sx={balaoInfoBottonStyle}>{numero}</Box>
		</Grid>
	);
}

/**
 * Espelha o ProductPath do campo. Lá o caminho é plantio → colheita →
 * distribuição → destino; aqui é o que a distribuidora enxerga: recebimento do
 * produtor, produção e expedição.
 */
function CaminhoProduto({ dados }) {
	return (
		<Box component="main" sx={{ width: "100%", height: { xs: "100%", sm: "90vh" }, m: 0 }}>
			<Grid
				container
				flexDirection="row"
				sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}
			>
				<Grid
					size={12}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						textAlign: "center",
						p: 2,
						width: "100%",
					}}
				>
					<Typography
						variant="h3"
						className={styles.titleProductPath}
						sx={{ fontWeight: "800", color: "#009199" }}
					>
						Conheça o caminho do seu produto...
					</Typography>
				</Grid>

				<Grid
					size={12}
					sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}
				>
					<Grid
						container
						rowSpacing={4}
						columnSpacing={{ xs: 0, sm: 1.5, md: 3 }}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "stretch",
							width: "100%",
						}}
					>
						<Balao
							titulo="Recebido"
							numero="01"
							destaque={formatDate(dados?.origem?.data)}
							texto="Esta é a data em que o produto chegou do produtor à distribuidora!"
						/>
						<Balao
							titulo="Produzido"
							numero="02"
							destaque={formatDate(dados?.producao?.data)}
							texto="Esta é a data em que o produto foi embalado!"
						/>
						<Balao
							titulo="Expedido"
							numero="03"
							destaque={formatDate(dados?.venda?.dataExpedicao)}
							texto="Esta é a data em que o produto saiu para o próximo destino!"
						/>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
}

export default memo(CaminhoProduto);
